import { lazy } from 'react';

import { renderRoutesFromArray } from './renderRoutesFromArray';

const Classrooms = lazy(() => import('../screens/main/classrooms/pages/classrooms'));
const SpecialitiesList = lazy(() => import('../screens/main/classrooms/pages/specialities-list'));
const SearchNetworksSessions = lazy(
  () => import('../screens/main/classrooms/pages/search-networks-sessions')
);
const NetworkSessionsBySpec = lazy(
  () => import('../screens/main/classrooms/pages/network-sessions-by-spec')
);
const ClassRoomDetails = lazy(() => import('../screens/main/classrooms/pages/classroom-details'));
const ClassRoom = lazy(() => import('../screens/main/classrooms/pages/classroom-single'));
const ClassroomLeaveDialog = lazy(
  () => import('../screens/main/classrooms/classroom-leave-dialog')
);
const ClassroomRules = lazy(() => import('../screens/main/classrooms/pages/classroom-rules'));
const ClassRoomLek = lazy(() => import('../screens/main/classrooms/pages/classroom-lek'));
const ClassRoomLekResults = lazy(
  () => import('../screens/main/classrooms/pages/classroom-lek-result')
);
const ClassRoomSearchMember = lazy(
  () => import('../screens/main/classrooms/pages/classroom-search-members')
);
const ClassroomLector = lazy(() => import('../screens/main/classrooms/pages/classroom-lector'));
const ClassroomOrganizer = lazy(
  () => import('../screens/main/classrooms/pages/classroom-organizer')
);
const ClassRoomActivityDetails = lazy(
  () => import('../screens/main/classrooms/pages/classroom-activity-details')
);

const routeDefinitions = [
  { path: '/classrooms/', element: <Classrooms /> },
  { path: '/biblio/', element: <SpecialitiesList /> },

  {
    path: '/biblio/search-sessions',
    element: <SearchNetworksSessions />,
  },
  {
    path: '/network-sessions-by-spec/:specialityGroupId',
    element: <NetworkSessionsBySpec />,
  },
  {
    path: '/classroom-details/:sessionId',
    element: <ClassRoomDetails />,
  },
  {
    path: '/classroom-details/:sessionId/:specialityGroupId',
    element: <ClassRoomDetails />,
  },
  {
    path: '/classroom/:sessionId',
    element: <ClassRoom />,
  },
  {
    path: '/classroom-finished/:sessionId',
    element: <ClassRoom isFinished />,
  },
  {
    path: '/classroom-finished/:sessionId/:userSessionSettingId',
    element: <ClassRoom isFinished />,
  },
  {
    path: '/classroom/:sessionId/:userSessionSettingId/activity-details',
    element: <ClassRoomActivityDetails />,
  },
  {
    path: '/classroom/:sessionId/:userSessionSettingId/leave',
    element: (
      <ClassRoom>
        <ClassroomLeaveDialog />
      </ClassRoom>
    ),
  },
  {
    path: '/classroom/:sessionId/search-members',
    element: <ClassRoomSearchMember />,
  },
  {
    path: '/classrooms/lector/:lectorId',
    element: <ClassroomLector />,
  },
  {
    path: '/classrooms/organizer/:organizerId',
    element: <ClassroomOrganizer />,
  },
  {
    path: '/classroom/:sessionId/lek/:lekSessionId',
    element: <ClassRoomLek />,
  },
  {
    path: '/classroom/:sessionId/lek-results',
    element: <ClassRoomLekResults />,
  },
  {
    path: '/classroom-rules/',
    element: <ClassroomRules />,
  },
];

const classroomRoutes = renderRoutesFromArray(routeDefinitions);

export default classroomRoutes;
